import React, { useRef } from 'react';
import { motion } from 'motion/react';
import TiltedCard from './react-bits/TiltedCard';
import Magnet from './react-bits/Magnet';
import './AppExperience.css';

import { EASE as ease, TIMING } from '../motion';
const modes = [
  {id:'voice',label:'宠语交流',icon:'wave',title:<>每一声呼唤，<br/>都值得被认真听见。</>,description:'从声音与行为线索出发，理解它可能的需求。用你的观察和反馈，让每一次交流更贴近它。',image:'app-translate.png',alt:'它来团宠物翻译界面',points:['听听它在表达什么','用熟悉的对话方式回应','留下你们的专属记忆'],note:'AI 分析提供可能的需求参考，请结合你的观察判断。'},
  {id:'location',label:'位置守护',icon:'pin',title:<>它去探索世界，<br/>你有牵挂的方向。</>,description:'查看最近位置、更新时间与设备状态。回看一起走过的路，让每一次外出心里有底。',image:'app-home.png',alt:'它来团位置与历史轨迹界面',points:['查看位置与更新时间','回看路线和历史轨迹','关注设备状态与找宠入口'],note:'定位与提醒受设备电量、网络和定位环境影响。'},
  {id:'memory',label:'专属陪伴',icon:'heart',title:<>平常的每一天，<br/>都是它的小故事。</>,description:'它有自己的名字、习惯和纪念日。把你们的对话与日常好好收藏，留下属于它的成长印记。',image:'app-memory.png',alt:'它来团宠物生日纪念界面',points:['属于它的专属形象','记录一起长大的日常','收藏生日与纪念时刻'],note:''}
];

function Glyph({name='arrow'}){
  const paths = {
    wave:<path d="M3 10v4m4-7v10m5-14v18m5-14v10m4-7v4"/>,
    pin:<><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2.4"/></>,
    heart:<path d="M20 5c-3-3-7-1-8 1-1-2-5-4-8-1-5 5 2 11 8 15 6-4 13-10 8-15Z"/>,
    arrow:<path d="M4 12h15m-6-6 6 6-6 6"/>
  };
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}

export default function AppExperience({active,onChange,reduced}){
  const tabs = useRef([]);
  const mode=modes[active];
  const next=(active+1)%modes.length;
  function selectTab(event,index){
    let destination;
    if(event.key==='ArrowRight')destination=(index+1)%modes.length;
    else if(event.key==='ArrowLeft')destination=(index+modes.length-1)%modes.length;
    else if(event.key==='Home')destination=0;
    else if(event.key==='End')destination=modes.length-1;
    else return;
    event.preventDefault();onChange(destination);tabs.current[destination]?.focus();
  }
  return <section className="experience" id="experience" aria-labelledby="experience-title">
    <div className="experience-heading shell"><h2 id="experience-title">一个 App，<br/>装下它的小世界。</h2><p>声音、位置、日常，<br/>每一件在意的事，都更近一点。</p></div>
    <div className="experience-theater">
      <div className="theater-topbar">
        <div className="theater-brand"><img src="assets/app-logo-user.png" alt=""/><span>它来团 App</span></div>
        <div className="experience-tabs" role="tablist" aria-label="App 核心体验">{modes.map((item,index)=><button key={item.id} id={`tab-${item.id}`} ref={el=>tabs.current[index]=el} role="tab" aria-selected={active===index} aria-controls={`panel-${item.id}`} tabIndex={active===index?0:-1} onClick={()=>onChange(index)} onKeyDown={e=>selectTab(e,index)}>
          {active===index&&<motion.span className="experience-tab-fill" layoutId={reduced?undefined:'experience-selection'} transition={{duration:TIMING.state,ease}}/>}<Glyph name={item.icon}/><span>{item.label}</span>
        </button>)}</div>
      </div>
      <div className="experience-copy">
        {modes.map((item,index)=><div key={item.id} id={`panel-${item.id}`} role="tabpanel" aria-labelledby={`tab-${item.id}`} tabIndex={0} hidden={index!==active}>
          <motion.div key={`${item.id}-${index===active}`} initial={false} animate={index===active&&!reduced?{y:[10,0],opacity:[.65,1]}:{y:0,opacity:1}} transition={{duration:TIMING.state,ease}}>
            <div className="experience-feature-name"><span/>{item.label}</div>
            <h3>{item.title}</h3><p className="experience-description">{item.description}</p>
            <ul>{item.points.map((point,i)=><li key={point}><span aria-hidden="true">{i===0?'—':'·'}</span>{point}</li>)}</ul>
            <p className="experience-note">{item.note}</p>
          </motion.div>
        </div>)}
        <Magnet disabled={reduced} padding={20} magnetStrength={7} maxOffset={4} spring={{stiffness:170,damping:27,mass:1}}><a href="#download" className="experience-download">探索它来团 App<Glyph/></a></Magnet>
      </div>
      <div className="experience-gallery" aria-label="App 界面展示">
        <div className="gallery-light" aria-hidden="true"/>
        <div className="gallery-floor" aria-hidden="true"/>
        <div className="phone-composition">{modes.map((item,index)=>{
          const position=(index-active+modes.length)%modes.length;
          const front=position===0;
          const pose=front?{x:0,y:-12,rotate:0,scale:1}:position===1?{x:166,y:34,rotate:11,scale:.84}:{x:-166,y:34,rotate:-11,scale:.84};
          return <motion.div key={item.id} className={`gallery-phone ${front?'is-front':'is-back'}`} data-position={front?'front':position===1?'right':'left'} data-screen={item.id} style={{zIndex:front?3:1}} initial={false} animate={pose} transition={{duration:reduced?0:TIMING.scene,ease}}>
            <TiltedCard containerWidth="304px" containerHeight="608px" imageWidth="304px" imageHeight="608px" rotateAmplitude={reduced?0:front?7:3} scaleOnHover={reduced?1:1.018} perspective={1200} glare={0} shadow={0} parallax={0} showTooltip={false} gyroscope={false} intro={false} radius={0} captionText={`查看${item.label}界面`} onClick={front?undefined:()=>onChange(index)} className="gallery-tilt">
              <img className="frozen-screen" src={`assets/${item.image}`} alt={item.alt} width="887" height="1774" draggable="false"/>
            </TiltedCard>
          </motion.div>;
        })}</div>
      </div>
      <div className="theater-bottom">
        <div className="experience-pagination" aria-label={`第 ${active+1} 个体验，共 3 个`}><span className="pagination-current">{String(active+1).padStart(2,'0')}</span><span className="pagination-track" aria-hidden="true"><motion.i initial={false} animate={{x:`${active*100}%`}} transition={{duration:reduced?0:TIMING.scene,ease}}/></span><span>03</span></div>
        <Magnet disabled={reduced} padding={15} magnetStrength={8} maxOffset={3} spring={{stiffness:170,damping:27,mass:1}}><button className="experience-next" onClick={()=>onChange(next)} aria-label={`下一个体验：${modes[next].label}`}><span>接下来，{modes[next].label}</span><span className="next-circle"><Glyph/></span></button></Magnet>
      </div>
    </div>
  </section>;
}
